import { useEffect, useState } from "react";
import { Grid, Breadcrumbs } from '@mui/material';
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { emphasize, styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import { ClientWallet } from "./ClientWallet";
import { useSellerStore } from "../../hooks/useSellerStore";
import WalletIcon from '@mui/icons-material/Wallet';
import { SellerModal } from "./components/SellerModal";
import StoreIcon from '@mui/icons-material/Store';
import { SellerBranches } from "./SellerBranches";
import EditRoadIcon from '@mui/icons-material/EditRoad';
import { RoadMap } from "./RoadMap";

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
        theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[800];
    return {
        backgroundColor,
        height: theme.spacing(3),
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(backgroundColor, 0.06),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(backgroundColor, 0.12),
        },
    };
});

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'rut', label: 'Rut', align:'center' },
    { type: 'text', field: 'name', label: 'Nombres', align:'center' },
    { type: 'text', field: 'surname', label: 'Apellidos', align:'center' },
    { type: 'text', field: 'phone', label: 'Teléfono', align:'center' },
    { type: 'text', field: 'email', label: 'Correo', align:'center' },
    // { type: 'text', field: 'address', label: 'Dirección', align:'center' },
    // { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const SellersView = () => {

    const { setActionSeller, getSellers, getSellersByCompany, deleteSeller } = useSellerStore();

    const [loading, setLoading] = useState<boolean>(false);
    const [sellers, setSellers] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    const [view, setView] = useState<String>('sellers');
    const [showWallet, setShowWallet] = useState<boolean>(false);
    const [showBranchOffices, setShowBranchOffices] = useState<boolean>(false);
    const [roadmap, setRoadmap] = useState<boolean>(false);

    useEffect(() => {
        getSellersApi();
    },[])

    const getSellersApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getSellers(search);
            console.log(response)
            if(!response){
                setSellers([]);
                setLoading(false);
                return false;
            }else{
                setSellers(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionSeller('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActionSeller('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionSeller('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected:any) => {
        setActionSeller('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteSeller(rowSelected.id)
            if(response){
                getSellersApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const onShowWallet = (rowSelected) => {
        setRowSelected(rowSelected);
        setView('wallet');
        setShowWallet(true);
    }
    const onShowBranches = (rowSelected) => {
        setRowSelected(rowSelected);
        setView('branches');
        setShowBranchOffices(true);
    }
    const onShowRoadmap = (rowSelected) => {
        setRowSelected(rowSelected);
        setView('roadmap');
        setRoadmap(true);
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getSellersApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{mt:3}}>
                <StyledBreadcrumb
                    label={"Maestros"}
                />
                <StyledBreadcrumb
                    label={"vendedores"}
                    onClick={() => {
                        setView('sellers');
                        setShowWallet(false);
                        setShowBranchOffices(false);
                        setRoadmap(false);
                        setRowSelected('');
                        getSellersApi();
                    }}
                />
                {
                    showWallet && (
                        <StyledBreadcrumb
                            label={"cartera de clientes"}
                            onClick={() => {setView('wallet')}}
                        />
                    )
                }
                {
                    showBranchOffices && (
                        <StyledBreadcrumb
                            label={"sucursales"}
                            onClick={() => {setView('branches')}}
                        />
                    )
                }
                {
                    roadmap && (
                        <StyledBreadcrumb
                            label={"Hoja de ruta"}
                            onClick={() => {setView('roadmap')}}
                        />
                    )
                }
            </Breadcrumbs>

            {
                view == 'sellers' && (
                    <Grid item xs={12}>
                        <CustomTable 
                            title={'Vendedores'}
                            columns={columns} 
                            loading={loading}
                            rows={sellers || []}
                            onRowClick={() => {}}
                            hasOptions
                            onAddFn={onAdd}
                            onAddFnName={'Nuevo vendedor'}
                            // onDetails={onDetails}
                            onDelete={onDelete}
                            onEdit={onEdit}
                            onSearch={onSearch}
                            onHelper={onShowWallet}
                            icon_helper={ <WalletIcon fontSize="small" /> }
                            tooltip_helper={'clientes'}
                            onHelper2={onShowBranches}
                            icon_helper2={ <StoreIcon fontSize="small" /> }
                            tooltip_helper2={'sucursales'}
                            onHelper4={onShowRoadmap}
                            icon_helper4={ <EditRoadIcon fontSize="small" /> }
                            tooltip_helper4={'hoja de ruta'}
                            dense
                        />
                    </Grid>
                )
            }
            {
                view == 'wallet' && (
                    <ClientWallet sellerSelected={rowSelected} />
                )
            }
            {
                view == 'branches' && (
                    <SellerBranches sellerSelected={rowSelected} />
                )
            }
            {
                view == 'roadmap' && (
                    <RoadMap sellerSelected={rowSelected} />
                )
            }
            {
                showModal && (
                    <SellerModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        sellerSelected = {rowSelected}
                        listsellers = {getSellersApi}
                        clearState = {clearState}
                        imported = {false}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}